export default "__VITE_ASSET__B_d5Z5Rz__"